import { RegentsAssignmentJuneCtrl } from './regents-assignment-june.controller';

export const RegentsAssignmentJuneComponent = {
  controller: RegentsAssignmentJuneCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./regents-assignment-june.html'),
};
